import { BaseUniDriver, UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';
import { dataHooks } from './constants';

export interface InfoIconUniDriver extends BaseUniDriver {
  hover(): Promise<void>;
  getSize(): Promise<string>;
  getContent(): Promise<string>;
  isTooltipOpen(): Promise<boolean>;
}

export const infoIconDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): InfoIconUniDriver => {
  const getTooltip = () => base.$(`[data-hook*="${dataHooks.tooltip}"]`);

  return {
    ...baseUniDriverFactory(base),

    /** Hover on icon. */
    hover: async () => getTooltip().hover(),

    /** Get size. */
    getSize: async () => base.attr('data-size') as Promise<string>,

    /** Get content as a text value. */
    getContent: async () => {
      const tooltipDriver = tooltipDriverFactory(getTooltip(), body);
      return tooltipDriver.getTooltipText() as Promise<string>;
    },

    /** Check if tooltip is open. */
    isTooltipOpen: async (): Promise<boolean> => {
      const tooltipDriver = tooltipDriverFactory(getTooltip(), body);
      return await tooltipDriver.tooltipExists();
    },
  };
};
